import { ComponentDocs } from "components/docs";

const DataListItem = () => (
  <ComponentDocs
    name="<DataList.Item/>"
    entry="DataListItem"
    propsEntry="DataListItemProps"
  />
);

export default DataListItem;
